export class MegaMenu {
  _wrapperEl = null;
  _linksElCollection = [];
  _level1MenuItemCollection = [];
  _level2MenuItemCollection = [];
  _level2WraperCollection = [];
  _level2MenuDetailsBlockCollection = [];
  _defaultLevel1Link = null;

  constructor(wrapperEl) {
    this._wrapperEl = wrapperEl;
    this._defaultLevel1Link = wrapperEl.querySelector('[mega-menu-default-level1-item]');
    this._linksElCollection = wrapperEl.querySelectorAll('.mega-menu_div-line-1 a, .mega-menu_div-line-2 a');
    this._levelsCollection = document.querySelectorAll('.mega-menu_div-line-1, .mega-menu_div-line-2');
    this._level1MenuItemCollection = wrapperEl.querySelectorAll('.mega-menu_div-line-1');
    this._level2MenuItemCollection = wrapperEl.querySelectorAll('.mega-menu_div-line-2');
    this._level2MenuDetailsBlockCollection = wrapperEl.querySelectorAll('.mega-menu_div-line-3');
    this._level2WraperCollection = wrapperEl.querySelectorAll('.mega-menu_line-2-wrapper');

    for (let link of this._linksElCollection) {
      link.addEventListener('mouseover', (event) => {
        this._onMenuItemChosen(event.target);
      });
      link.addEventListener('click', (event) => {        
        this._onMenuItemClicked(event.target);
      });
    }
  }

  renderDefaultState() {
    this._hideAllChildren();
    if (this._defaultLevel1Link) {
      this._onMenuItemChosen(this._defaultLevel1Link);
    }
  }

  _onMenuItemChosen(linkEl) {
    this._hideAllChildren(linkEl);
    this._showRelatedChildren(linkEl);
  }

  _onMenuItemClicked(linkEl) {
    this._levelsCollection.forEach((level) => {
      level.classList.remove('active');
    });

    let parent = linkEl.parentNode;

    if(this._level2MenuItemCollection.length) {
      parent.classList.add('active');
    }
    this._highlightClickedMenuItemParent(linkEl);
  }

  _highlightClickedMenuItemParent(linkEl) {
    if(this._isLevel2Link(linkEl)) {
      this._level1MenuItemCollection.forEach((elt) => {
        if(elt.classList.contains('opened')) {
          elt.classList.add('active');
        }
      });      
    }
  }


  _highlightChosenMenuItem(linkEl) {

    this._level2MenuItemCollection.forEach((elt) => {
      elt.classList.remove('opened');
    });

    if (this._isLevel1Link(linkEl)) {
      this._level1MenuItemCollection.forEach((elt) => {
        elt.classList.remove('opened');
      });
    }

    let parent = linkEl.parentNode;

    if(this._level2MenuItemCollection.length) {
      parent.classList.add('opened');
    }

  }

  _hideAllChildren(linkEl) {
    if (linkEl == null || this._isLevel1Link(linkEl)) {
      this._level2WraperCollection.forEach((elt) => {
        elt.classList.add('hide');
      })
    }

    this._level2MenuDetailsBlockCollection.forEach((elt) => {
      elt.classList.add('hide');
    })
  }

  _showRelatedChildren(linkEl) {
    this._highlightChosenMenuItem(linkEl);
    let target = this._wrapperEl.querySelector("#" + linkEl.getAttribute("data-id"));

    if (target) {
      target.classList.remove('hide');
      target.classList.add('opened');

      if (this._isLevel1Link(linkEl)) {
        let relatedChildMenuItem = target.querySelector('[mega-menu-default-level2-item]');
        if (relatedChildMenuItem) {
          this._showRelatedChildren(relatedChildMenuItem);
        }
      }
    }
  }

  _isLevel1Link(linkEl) {
    return linkEl.classList.contains('mega-menu_line-1-text');
  }

  /**
   *
   * @param {HTMLLinkElement} linkEl
   * @private
   */
  _isLevel2Link(linkEl) {
    return linkEl.classList.contains('mega-menu_line-2-text');
  }
  
}